// Web code for Startup
import {
  FontFamilyMedium,
  FontFamilyMonoSemibold,
  FontFamilyRegular,
  FontFamilySemibold,
} from 'lib/theme';
import { Asset } from 'expo-asset';

/** @ts-expect-error font is available */
import SFProTextRegular from 'assets/fonts/SFProTextRegular.ttf';
/** @ts-expect-error font is available */
import SFProTextMedium from 'assets/fonts/SFProTextMedium.ttf';
/** @ts-expect-error font is available */
import SFProTextSemibold from 'assets/fonts/SFProTextSemibold.ttf';
/** @ts-expect-error font is available */
import SFMonoSemibold from 'assets/fonts/SFMonoSemibold.otf';

const SFProTextRegularURI = Asset.fromModule(SFProTextRegular).uri;
const SFProTextMediumURI = Asset.fromModule(SFProTextMedium).uri;
const SFProTextSemiboldURI = Asset.fromModule(SFProTextSemibold).uri;
const SFMonoSemiboldURI = Asset.fromModule(SFMonoSemibold).uri;

const ProTextRegular = `@font-face {
  src: url('${SFProTextRegularURI}');
  font-family: '${FontFamilyRegular}';
}`;
const ProTextMedium = `@font-face {
  src: url('${SFProTextMediumURI}');
  font-family: '${FontFamilyMedium}';
}`;
const ProTextSemibold = `@font-face {
  src: url('${SFProTextSemiboldURI}');
  font-family: '${FontFamilySemibold}';
}`;
const MonoSemibold = `@font-face {
  src: url('${SFMonoSemiboldURI}');
  font-family: '${FontFamilyMonoSemibold}';
}`;

// Create stylesheet
const style = document.createElement('style');
style.appendChild(document.createTextNode(ProTextRegular));
style.appendChild(document.createTextNode(ProTextMedium));
style.appendChild(document.createTextNode(ProTextSemibold));
style.appendChild(document.createTextNode(MonoSemibold));

// Inject stylesheet
document.head.appendChild(style);
